import { createClient } from '@sanity/client';

export const sanityClient = createClient({
  projectId: "025rxk3o",        // Your Sanity project ID
  dataset: 'production',        // Default dataset
  apiVersion: '2024-03-19',     // Use today's date
  useCdn: true,                // Enable CDN for better performance
  perspective: 'published',     // Only fetch published content
  stega: false,                // Disable stega for development
  token: import.meta.env.VITE_SANITY_TOKEN, // Optional: Add token if needed for private datasets
});
